import {DcpApiConfig} from '@app/model/custom-config/dcp-api-config.model';

export const DCP_API_CONFIG: DcpApiConfig = {
  backend: {
    occ: {
      endpoints: {
        paymentDetails: '/users/current/paymentdetails', // NOSONAR
        fullPaymentDetails: '/users/${userId}/carts/${cartId}/fullPaymentDetails', // NOSONAR
        paymentModes: '/users/${usedId}/carts/paymentmodes', // NOSONAR
        basestoresByCountry: '/basestores/country/${countryCode}', // NOSONAR
        cartContact: '/users/${userId}/carts/${cartId}/addresses/${contactUid}?fields=DEFAULT&usage=${usage}', // NOSONAR
        cartAddress:
          '/users/${userId}/carts/${cartId}/addresses/${ownerUid}?fields=DEFAULT&usage=${addressUsage}&addressUid=${addressUid}&externalAddressNumber=${externalAddressNumber}&addressPk=${addressPk}', //NOSONAR
        currentUser: '/users/current', // NOSONAR
        currentUserWithJson: '/users/current?fields=DEFAULT,json', // NOSONAR
      },
      routes: {
        checkout: '/checkout',
        reviewOrder: '/checkout/review-order',
      },
    },
  },
};
